export class UploadErrors {
    public static FILE_SIZE: string = 'FILE_ERROR_SIZE';
    public static FILE_TYPE: string = 'FILE_ERROR_TYPE';
    public static FILE_UNKNOWN: string = 'FILE_ERROR_UNKNOWN';
}
